/* One observer for site reveals; CSS owns product-card hover. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer;
  var index = 0;
  var selector = '.grid-product, .grid__item, .section-header, .product-block, .jp-reveal-auto';

  function disabled() {
    return root.dataset.jpMotion !== 'true' ||
      root.dataset.jpMotionDisabled === 'true' ||
      reduced.matches;
  }

  function revealAll() {
    if (observer) observer.disconnect();
    document.querySelectorAll('.jp-global-pending').forEach(function (element) {
      element.classList.add('is-in');
    });
  }

  function refresh() {
    if (disabled() || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.01, rootMargin: '0px 0px 50px 0px' });
    }

    document.querySelectorAll(selector).forEach(function (element) {
      if (element.classList.contains('jp-global-pending') || element.classList.contains('is-in')) return;
      if (element.closest('[data-jp-reveal], .appear-animation')) return;

      var bounds = element.getBoundingClientRect();
      if (bounds.top < window.innerHeight && bounds.bottom > 0) {
        element.classList.add('is-in');
        return;
      }
      element.style.setProperty('--i', String(index++ % 6));
      element.classList.add('jp-global-pending');
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.addEventListener('jp:cart', refresh);
  document.addEventListener('shopify:section:load', refresh);
  reduced.addEventListener('change', function () {
    if (disabled()) revealAll();
    else refresh();
  });
  window.jpGlobalRefresh = refresh;
}());
